export const APP_URL =
  process.env.NEXT_PUBLIC_APP_URL ?? 'https://campuslush.com';
export const API_URL = process.env.NEXT_PUBLIC_API_URL ?? '';
export const BRAZE_ENDPOINT = 'sdk.iad-05.braze.com';
export const BRAZE_API_KEY = 'f75c5688-0ac2-4125-bcf0-0ee1789e92e8';
export const RECAPTCHA_SITE_KEY = '6LdOJxssAAAAAJSe-VX_R_1PqgBVSrECtFWX-BKl';

const DEFAULT_SENTRY_DSN =
  'https://6641b35ec8ba46ba272f529f4ef6cf57@o4511571552501760.ingest.us.sentry.io/4511687979892736';
export const SENTRY_DSN =
  process.env.NEXT_PUBLIC_SENTRY_DSN ?? DEFAULT_SENTRY_DSN;
export const SENTRY_ENVIRONMENT =
  process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ??
  process.env.NODE_ENV ??
  'development';
export const SENTRY_TRACES_SAMPLE_RATE = Number(
  process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? '0.1',
);
export const isSentryEnabled = Boolean(SENTRY_DSN);

